import {
	Breadcrumbs,
	useGetBackUrlFromLocation,
} from "@sembark-travel/ui-router"
import { generatePath } from "../../../router-utils"
import { Helmet } from "react-helmet-async"
import { Box, Container } from "@sembark-travel/ui-base"
import { useNavigate } from "react-router"
import { NewVisaService } from "../../../Visa"

const NewVisaServicePage = () => {
	const backFromUrl = useGetBackUrlFromLocation()
	const navigate = useNavigate()
	return (
		<>
			<Helmet>
				<title>New Visa</title>
			</Helmet>
			<Breadcrumbs
				title="New Service"
				items={[
					[generatePath("/visa"), "Visa"],
					["", "New"],
				]}
			/>
			<Box paddingY={{ md: "8" }}>
				<Box maxWidth="6xl" marginX="auto">
					<Box rounded="lg" bgColor="default">
						<Container paddingY="4" paddingX="0">
							<NewVisaService
								onSuccess={() => {
									navigate(generatePath("/visa"))
								}}
								onCancel={() =>
									backFromUrl
										? navigate(backFromUrl)
										: navigate(generatePath("/visa"))
								}
							/>
						</Container>
					</Box>
				</Box>
			</Box>
		</>
	)
}

export default NewVisaServicePage
